import React from "react";
import { Link } from "react-router-dom";
import { IoLogoTwitter, IoLogoInstagram, IoLogoFacebook, IoLogoPinterest } from "react-icons/io5";

export default function Copyright (props) {
    return (
        <div className="copyright">
            <div className="company">
                <div>Created by <Link to="https://twitter.com/Devvyhac">@Devvyhac</Link></div>
                <div>
                    <span><Link to="#"><IoLogoTwitter className="social-icon" /></Link></span>
                    <span><Link to="#"><IoLogoInstagram className="social-icon" /></Link></span>
                    <span><Link to="#"><IoLogoFacebook className="social-icon" /></Link></span>
                    <span><Link to="#"><IoLogoPinterest className="social-icon" /></Link></span>
                </div>
            </div>
            <Projects />
        </div>
    )
}

function Projects (props) {
    return (
        <div className="projects">
            <div className="company-name">
                Tracetechie company projects
            </div>
            <ul className="project-list">
                <li><a href="https://www.farmvest.000webhostapp.com">Farmapropos</a></li>
                <li><a href="https://tracemall.herokuapp.com/">Tracemall</a></li>
                <li><a href="https://devvyhac.github.io/devvyhac">Devvyhac</a></li>
            </ul>
        </div>
    )
}